import { LayoutItem, LayoutItemType } from '@blockworks/platform/api/research/studio';
import { Bit, BitProps } from '@blockworks/ui/factory';
import { cn } from '@blockworks/ui/system';

import { useDashboardGridContext } from '../../context';
import { ItemHeightBadge } from '../grid-item-placeholder';

import { MarkdownGridItem } from './markdown-item';
import { VisualizationItem } from './visualization-item';

type GridItemContentProps = {
    item: LayoutItem;
};

const CONTENT_COMPONENT_BY_TYPE: Record<LayoutItemType, typeof MarkdownGridItem | typeof VisualizationItem | null> = {
    [LayoutItemType.Markdown]: MarkdownGridItem,
    [LayoutItemType.Counter]: VisualizationItem,
    [LayoutItemType.Table]: VisualizationItem,
    [LayoutItemType.Timeseries]: VisualizationItem,
    [LayoutItemType.Pie]: VisualizationItem,
    [LayoutItemType.Sankey]: VisualizationItem,
};

const ContentWrapper = ({ className, ...props }: BitProps<'div'>) => (
    <Bit.div
        display="flex"
        w="full"
        overflow="auto"
        flex={1}
        h="full"
        alignItems="center"
        justifyContent="center"
        className={cn('scroller', className)}
        {...props}
    />
);

const GridItemContent = ({ item }: GridItemContentProps) => {
    const { isEditable } = useDashboardGridContext();

    /** temporary message for us for debugging */
    if (!item.data?.type) return <ContentWrapper>A viz type is not provided for this viz. ID: {item.i}</ContentWrapper>;
    const Content = CONTENT_COMPONENT_BY_TYPE[item.data.type];

    /** temporary message for us for debugging */
    if (!Content) {
        console.error(`A viz type is not supported for this viz. ID: ${item.data.id} type: ${item.data.type}`);
        return (
            <ContentWrapper>
                A viz type is not supported for this viz. ID: {item.data.id} type: {item.data.type}
            </ContentWrapper>
        );
    }

    return (
        <ContentWrapper className={cn({ 'pointer-events-none': isEditable })}>
            <Content item={item} />
            {isEditable && <ItemHeightBadge height={item.h} />}
        </ContentWrapper>
    );
};

export type { GridItemContentProps };
export { GridItemContent };
